import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import TagManager from 'react-gtm-module';
import Tooltip  from 'rc-tooltip';
import { getRecaptchaEnterpriseToken } from '../utils/recaptchaEnterprise';
import GuestFrame from './GuestFrame.js';
import PredictiveStreetSearch from './PredictiveStreetSearch.js';
import LoadingFull from './LoadingFull';
import {formatRut, checkRut, isEmailValid, formatEmail} from '../utils.js';
import OrangeArrow from '../img/arrow_orange.png';
import { registerCompany } from '../api.js';

const DISPLAY_DATA = Object.freeze({
	COMPANY:"COMPANY",
	ADMIN:"ADMIN",
	SUCCESS:"SUCCESS",
	ERROR:"ERROR"
});
const FIELDS = Object.freeze({
	rutCompany: "rutCompany",
	nameCompany: "nameCompany",
	addressCompany: "addressCompany",
	rutAdmin: "rutAdmin",
	nameAdmin: "nameAdmin",
	emailAdmin: "emailAdmin",
	phoneAdmin: "phoneAdmin"
})
export default class RegisterEmpresa extends Component  {

	constructor(props) {
		super(props);
		this.state = {
			displayDataShow: DISPLAY_DATA.COMPANY,
			[FIELDS.rutCompany]: "",
			[FIELDS.nameCompany]: "",
			[FIELDS.addressCompany]: "",
			[FIELDS.rutAdmin]: "",
			[FIELDS.nameAdmin]: "",
			[FIELDS.emailAdmin]: "",
			[FIELDS.phoneAdmin]: "",
			errors: {},
			loading: false
		}

		this.gtmTimeout = null;
		this.sendCustomEventGTM({event:"sv_register_visita"});
	}
	
	componentWillUnmount() {
		clearTimeout(this.gtmTimeout);
	}

	sendCustomEventGTM({event, metadata={}}){
		if (!event) return;
		const trigger = "COMPANY_REQUEST";
		TagManager.dataLayer({ 
			dataLayer:{ event, metadata: { trigger , ...this.state, ...metadata} } 
		});
	}

	trackFieldInteraction() {
		clearTimeout(this.gtmTimeout);
		this.gtmTimeout = setTimeout(() => {
			this.sendCustomEventGTM({ event: "sv_register_interaccion_campos" });
		}, 1000);
	}

	isSectionVaild(){
		const { displayDataShow } = this.state;
		const {rutCompany, nameCompany, addressCompany, rutAdmin, nameAdmin, emailAdmin, phoneAdmin} = FIELDS;
		const {COMPANY, ADMIN} = DISPLAY_DATA;
		const isCompanySectionvalid = [rutCompany, nameCompany, addressCompany].every(field => !this.hasFieldError(field));
		const isAdminSectionValid = [rutAdmin, nameAdmin, emailAdmin, phoneAdmin].every(field => !this.hasFieldError(field));
		
		const sectionsValid = {
			[COMPANY]: isCompanySectionvalid,
			[ADMIN]: isAdminSectionValid,
		}

		this.updateDisplayErrors();

		return sectionsValid[displayDataShow];
	}

	hasFieldError = (field) => {
		if(!(field in FIELDS)) return false;
		const { displayDataShow, rutCompany, nameCompany, addressCompany, rutAdmin, nameAdmin, emailAdmin, phoneAdmin } = this.state;

		const mapFields = {
			[DISPLAY_DATA.COMPANY] : {
				[FIELDS.rutCompany]: !checkRut(rutCompany),
				[FIELDS.nameCompany]: !nameCompany.trim(),
				[FIELDS.addressCompany]: !addressCompany,
			},
			[DISPLAY_DATA.ADMIN] : {
				[FIELDS.rutAdmin]: !checkRut(rutAdmin),
				[FIELDS.nameAdmin]: !nameAdmin.trim(),
				[FIELDS.emailAdmin]: !!emailAdmin && !isEmailValid(emailAdmin),
				[FIELDS.phoneAdmin]: !(phoneAdmin.length === 9),
			}			
		}

		return mapFields[displayDataShow][field];
	}

	updateDisplayErrors(field=undefined) {
		const { rutCompany,nameCompany,addressCompany,rutAdmin,nameAdmin,emailAdmin,phoneAdmin } = FIELDS;
		const errors = {
			[rutCompany]: this.hasFieldError(rutCompany) ? "El rut ingresado no es válido": undefined,
			[nameCompany]: this.hasFieldError(nameCompany) ? "Campo requerido" : undefined,
			[addressCompany]: this.hasFieldError(addressCompany) ? "Campo requerido" : undefined,
			[rutAdmin]: this.hasFieldError(rutAdmin) ? "El rut ingresado no es válido": undefined ,
			[nameAdmin]: this.hasFieldError(nameAdmin) ? "Campo requerido" : undefined,
			[emailAdmin]: this.hasFieldError(emailAdmin) ? "Email debe contener . y @" : undefined,
			[phoneAdmin]: this.hasFieldError(phoneAdmin) ? "Teléfono debe contener 9 dígitos" : undefined,
		}


		if(field && field in FIELDS) return this.setState({errors:{...this.state.errors, [field]: errors[field] }});

		return this.setState({errors});
	}

	async sendForm() {
		this.setState({loading: true});

		const {createActionNotification} = this.props;
		const recaptcha_token = await getRecaptchaEnterpriseToken('solicitud_cuenta_empresa') || null;
		const {rutCompany, nameCompany, addressCompany, rutAdmin, nameAdmin, emailAdmin, phoneAdmin} = this.state
		const body = {
			empresa_rut: rutCompany, 
			empresa_razon_social: nameCompany,
			direccion: addressCompany?.formatedValue ?? "",
			comuna: addressCompany?.city ?? "",
			latitud: Number(addressCompany?.latitud) ?? 0,
			longitud: Number(addressCompany?.longitud) ?? 0,
			admin_rut: rutAdmin,
			admin_nombre: nameAdmin,
			admin_email: emailAdmin,
			admin_telefono: phoneAdmin,
			recaptcha_token
		}

		registerCompany(body, (err,result) => {
			this.setState({loading: false}, ()=> {
				if(err || result.status !== "success") {
					return this.setState({displayDataShow: DISPLAY_DATA.ERROR}, ()=> 
						createActionNotification('Error', "Proceso no completado, intente nuevamente", 'error')
					);
				}

				this.setState({displayDataShow: DISPLAY_DATA.SUCCESS}, ()=> 
					this.sendCustomEventGTM({event:"sv_register_click_registrarme"})
				);
			})
		});
	}

	render() {
		return (
			<GuestFrame>
				{this.state.loading && < LoadingFull />}
				<div className="login-container register-container">
					<div className="background-flame">
						{(this.state.displayDataShow === DISPLAY_DATA.COMPANY || 
						this.state.displayDataShow === DISPLAY_DATA.ADMIN) && <>
							<svg 
							width="38" 
							height="36" 
							viewBox="0 0 38 36" 
							fill="none" 
							xmlns="http://www.w3.org/2000/svg"
							className='block-important mx-auto mt-20'>
								<path d="M18.75 16.5869C16.3367 16.5869 14.351 15.8079 12.7931 14.25C11.2356 12.6925 10.4569 10.7071 10.4569 8.29375C10.4569 5.86417 11.2356 3.87458 12.7931 2.325C14.351 0.775001 16.3367 0 18.75 0C21.1633 0 23.149 0.775001 24.7069 2.325C26.2644 3.87458 27.0431 5.86417 27.0431 8.29375C27.0431 10.7071 26.2644 12.6925 24.7069 14.25C23.149 15.8079 21.1633 16.5869 18.75 16.5869ZM0 32.7787V30.9181C0 29.5752 0.355833 28.4054 1.0675 27.4088C1.77917 26.4121 2.70375 25.646 3.84125 25.1106C6.47292 23.941 9.00979 23.0596 11.4519 22.4662C13.8944 21.8733 16.3271 21.5769 18.75 21.5769C21.1729 21.5769 23.5992 21.8798 26.0288 22.4856C28.4583 23.0915 30.9887 23.9665 33.62 25.1106C34.7833 25.646 35.7208 26.4121 36.4325 27.4088C37.1442 28.4054 37.5 29.5752 37.5 30.9181V32.7787C37.5 33.58 37.2196 34.261 36.6587 34.8219C36.0979 35.3831 35.4169 35.6638 34.6156 35.6638H2.88437C2.08312 35.6638 1.40208 35.3831 0.84125 34.8219C0.280417 34.261 0 33.58 0 32.7787Z" fill="white"/>
							</svg>

							<h2 className="mt-12" style={{fontSize:20, fontWeight: 600}}>
								Solicitud de creación de Administrador Empresa en Sucursal Virtual
							</h2>
						</>}
						
						{this.state.displayDataShow === DISPLAY_DATA.COMPANY && <>
							<div className="register-container margin-top-30 grid-column-1 col-100">
								<div className="login-field-container">
									<p style={{fontWeight:500}}>
										Ingresa el RUT de la empresa que tiene contrato actual con Abastible*
									</p>
									<Tooltip 
									placement="bottom" 
									visible={ Boolean(this.state.errors.rutCompany) }
									overlay={<span> {this.state.errors.rutCompany} </span>}>
										<input
										maxLength={10}
										value={this.state.rutCompany}
										onChange={(e) => {
											const rutCompany = formatRut(e.target.value);
											this.setState({rutCompany}, ()=>{
												this.updateDisplayErrors(FIELDS.rutCompany);
												this.trackFieldInteraction();
											})
										}} />
									</Tooltip>
								</div>

								<div className="login-field-container">
									<p style={{fontWeight:500}}>
										Razón Social (nombre) de la Empresa*
									</p>
									<Tooltip 
									placement="bottom" 
									visible={ Boolean(this.state.errors.nameCompany)}
									overlay={<span> {this.state.errors.nameCompany} </span>}>
										<input
										value={this.state.nameCompany}
										pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*"
										maxLength={100}
										onBlur={()=>{
											const nameCompany = this.state.nameCompany.trim();
											this.setState({nameCompany});
										}}
										onChange={(e) => {
											const nameCompany = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '').slice(0, 100);
											this.setState({nameCompany}, ()=>{
												this.updateDisplayErrors(FIELDS.nameCompany);
												this.trackFieldInteraction();
											});
										}} />
									</Tooltip>
								</div>

								<div className="login-field-container">
									<p style={{fontWeight:500}}>
										Dirección completa de la Empresa (Calle, Número, Comuna) *
									</p>
									<Tooltip 
									placement="bottom" 
									visible={ Boolean(this.state.errors.addressCompany)}
									overlay={<span> {this.state.errors.addressCompany} </span>}>
										<PredictiveStreetSearch 
										placeholder="" 
										getDataOnPalceChanged={(data)=> {
											this.setState({addressCompany: data}, ()=> {
												this.updateDisplayErrors(FIELDS.addressCompany)
												this.trackFieldInteraction();
											});
										}} />
									</Tooltip>
								</div>

								<button  
								className="login-submit-button mt-12" 
								style={{paddingInline:0}}
								onClick={() => {
									if(this.isSectionVaild()) this.setState({displayDataShow: DISPLAY_DATA.ADMIN})} 
								}>
									Continuar
								</button>

								<Link 
								to={"/login"} 
								onClick={()=> this.sendCustomEventGTM({event:"sv_register_click_volver"})}>
									<span 
									className='block-important text-center mx-auto' 
									style={{color:"white", borderBottom:"1px dashed", width:"fit-content"}}>
										Volver
									</span>
								</Link>
							</div>
						</>
						}

						{this.state.displayDataShow === DISPLAY_DATA.ADMIN &&
							<div className="register-container margin-top-30 grid-column-1 col-100">
								<div className="login-field-container">
									<p style={{fontWeight:500}}>
										RUT del Administrador *
									</p>
									<Tooltip 
									placement="bottom" 
									visible={ Boolean(this.state.errors.rutAdmin) }
									overlay={<span> {this.state.errors.rutAdmin} </span>}>
										<input
										maxLength={10}
										value={this.state.rutAdmin}
										onChange={(e) => {
											const rutAdmin = formatRut(e.target.value);
											this.setState({rutAdmin}, ()=> {
												this.updateDisplayErrors(FIELDS.rutAdmin);
												this.trackFieldInteraction();
											});
										}} />
									</Tooltip>
								</div>
								
								<div className="login-field-container">
									<p style={{fontWeight:500}}>
										Nombre completo del Administrador *
									</p>
									<Tooltip 
									placement="bottom" 
									visible={ Boolean(this.state.errors.nameAdmin)}
									overlay={<span> {this.state.errors.nameAdmin} </span>}>
										<input
										value={this.state.nameAdmin}
										pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*"
										maxLength={100}
										onChange={(e) => {
											const nameAdmin = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '').slice(0,100);
											this.setState({nameAdmin}, ()=>{
												this.updateDisplayErrors(FIELDS.nameAdmin);
												this.trackFieldInteraction();
											});
										}} />
									</Tooltip>
								</div>
								
								<div className='grid-column-2'>
									<div className="login-field-container">
										<p style={{fontWeight:500}}>
											Correo electrónico del Administrador
										</p>
										<Tooltip 
										placement="bottom" 
										visible={ Boolean(this.state.errors.emailAdmin)}
										overlay={<span> {this.state.errors.emailAdmin} </span>}>
											<input
											maxLength={150}
											value={this.state.emailAdmin}
											onChange={(e) => {
												const emailAdmin = formatEmail(e.target.value).slice(0,150);
												this.setState({emailAdmin}, ()=>{
													this.updateDisplayErrors(FIELDS.emailAdmin);
													this.trackFieldInteraction();
												});
											}} />
										</Tooltip>
									</div>

									<div className="login-field-container">
										<p style={{fontWeight:500}}>
											Teléfono del Administrador *
										</p>
										<Tooltip 
										placement="bottom" 
										visible={ Boolean(this.state.errors.phoneAdmin)}
										overlay={<span>{ this.state.errors.phoneAdmin}</span>}>
											<input
											value={this.state.phoneAdmin}
											pattern="[0-9]*"
											maxLength={9}
											onChange={(e) => {
												const phoneAdmin = e.target.value.replace(/[^0-9]/g, '').slice(0,9);
												this.setState({phoneAdmin}, ()=>{
													this.updateDisplayErrors(FIELDS.phoneAdmin);
													this.trackFieldInteraction();
												});
											}} />
										</Tooltip>
									</div>
								</div>

								<button  
								className="login-submit-button" 
								style={{paddingInline:0}}
								onClick={()=> {
									if(this.isSectionVaild()) this.sendForm();
								} }>
									Enviar solicitud
								</button>

								<button 
								className='block-important text-center mx-auto' 
								style={{color:"white", borderBottom:"1px dashed", width:"fit-content", backgroundColor:"transparent"}}
								onClick={()=> {
									this.sendCustomEventGTM({event:"sv_register_click_volver"})
									this.setState({displayDataShow: DISPLAY_DATA.COMPANY})
								}}>
									Volver
								</button>
							</div>
						}

						{this.state.displayDataShow === DISPLAY_DATA.ERROR &&
							<div className="register-container col-100" style={{paddingBlock:90}}>
								<svg 
								width="60" 
								height="60"
								className='mx-auto block-important'
								viewBox="0 0 38 38" 
								fill="none" 
								xmlns="http://www.w3.org/2000/svg">
									<path d="M19 20.6L25.623 27.223C25.846 27.446 26.1095 27.5608 26.4135 27.5675C26.7172 27.5738 26.987 27.459 27.223 27.223C27.459 26.987 27.577 26.7203 27.577 26.423C27.577 26.1257 27.459 25.859 27.223 25.623L20.6 19L27.223 12.377C27.446 12.154 27.5608 11.8905 27.5675 11.5865C27.5738 11.2828 27.459 11.013 27.223 10.777C26.987 10.541 26.7203 10.423 26.423 10.423C26.1257 10.423 25.859 10.541 25.623 10.777L19 17.4L12.377 10.777C12.154 10.554 11.8905 10.4392 11.5865 10.4325C11.2828 10.4262 11.013 10.541 10.777 10.777C10.541 11.013 10.423 11.2797 10.423 11.577C10.423 11.8743 10.541 12.141 10.777 12.377L17.4 19L10.777 25.623C10.554 25.846 10.4392 26.1095 10.4325 26.4135C10.4262 26.7172 10.541 26.987 10.777 27.223C11.013 27.459 11.2797 27.577 11.577 27.577C11.8743 27.577 12.141 27.459 12.377 27.223L19 20.6ZM19.0035 38C16.3962 38 13.9395 37.5013 11.6335 36.504C9.3275 35.5067 7.311 34.1448 5.584 32.4185C3.857 30.6922 2.4945 28.6765 1.4965 26.3715C0.498833 24.0668 0 21.6108 0 19.0035C0 16.3755 0.498667 13.9053 1.496 11.593C2.49333 9.28067 3.85517 7.26933 5.5815 5.559C7.30783 3.84867 9.3235 2.4945 11.6285 1.4965C13.9332 0.498833 16.3892 0 18.9965 0C21.6245 0 24.0947 0.498666 26.407 1.496C28.7193 2.49333 30.7307 3.84683 32.441 5.5565C34.1513 7.26617 35.5055 9.27667 36.5035 11.588C37.5012 13.8993 38 16.3688 38 18.9965C38 21.6038 37.5013 24.0605 36.504 26.3665C35.5067 28.6725 34.1532 30.689 32.4435 32.416C30.7338 34.143 28.7233 35.5055 26.412 36.5035C24.1007 37.5012 21.6312 38 19.0035 38Z" fill="#FFF"/>
								</svg>

								<h2 className='mt-32' style={{fontSize:24, fontWeight:600}}>
									No hemos podido enviar tu solicitud
								</h2>
								<p className="color-white mt-16 text-center">
									No pudimos procesar tu solicitud. Por favor, intenta nuevamente o comunícate con nuestro
									&nbsp;
									<a className='color-white' style={{borderBottom:"1px dashed"}} href='tel:800209000'>
										Call Center al 800 20 9000
									</a>
								</p>

								<button
								className="login-submit-button mt-52 mx-auto" 
								style={{padding: '10px 40px', display:'flex', gap:10, alignItems:'center',}}
								onClick={() => this.props.redirect("/login")}>
									IR AL INICIO
									<img 
									src={OrangeArrow} 
									alt="icono de flecha"
									style={{ height:10 }} />
								</button>
							</div>
						}

						{this.state.displayDataShow === DISPLAY_DATA.SUCCESS &&
							<div className="register-container col-100" style={{paddingBlock:120}}>
								<h2 style={{fontSize:24, fontWeight:600}}>
									Se ha enviado la solicitud exitosamente
								</h2>
								<p className="color-white text-center mt-20">
									Muchas gracias por completar el formulario. En un plazo de 24 hrs hábiles, recibiras en tu correo tu contraseña para ingresar a sucursal virtual.
								</p>

								<button
								className="login-submit-button mt-32 mx-auto" 
								style={{padding: '10px 40px', display:'flex', gap:10, alignItems:'center',}}
								onClick={() => this.props.redirect("/login")}>
									IR AL INICIO
									<img 
									src={OrangeArrow} 
									alt="icono de flecha"
									style={{ height:10 }} />
								</button>
							</div>
						}
					</div>
				</div>
			</GuestFrame>
		);
	}
}
